import Box from "@mui/material/Box";
import Text from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { Colors } from "../../../utils/constants";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { SxProps } from "@mui/material";

export const modalBaseStyles: SxProps = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  color: "#000",
  borderRadius: "0.2rem",
  p: 2,
};

interface PropType {
  show: boolean;
  alertName: string;
  onClose: () => void;
  deleteAlert: () => void;
  infoText?: string;
}

export default function DeleteSearchModal(props: PropType) {
  const { show, alertName, onClose, deleteAlert, infoText } = props;
  return (
    <Modal
      open={show}
      onClose={onClose}
      aria-labelledby="PreprintDeleteModal-Title"
      aria-describedby="PreprintDeleteModal-Description"
    >
      <Box
        sx={{
          ...modalBaseStyles,
          display: "flex",
          flexDirection: "column",
          width: "35vw",
          maxHeight: "77vh",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Text
            id="modal-modal-title"
            sx={{
              fontWeight: 600,
              fontSize: "1.4rem",
              textAlign: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            Delete Alert - {alertName}
          </Text>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Text sx={{}}>
          {infoText ? infoText : "Are you sure you want to permanently delete this alert?"}
        </Text>

        <Box sx={{ width: "100%", my: 2 }}>
          <Button
            variant="contained"
            sx={{ px: "3rem", py: "0.5rem", mr: 2 }}
            onClick={deleteAlert}
          >
            Delete Alert
          </Button>
          <Button sx={{ color: Colors.black }} onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
